import * as Yup from 'yup';

/**
 * 退税品牌item
 */
export interface DrawbackItem {
  /**
   * 品牌名称
   */
  brand: string;
  /**
   * 金额
   */
  money: string;
}

/**
 * 退税登记
 */
export interface DrawbackInfo {
  /**
   * 服务id(编辑的时候传)
   */
  id?: string;
  /**
   * 会员id
   */
  member_id?: string;
  /**
   * 非会员id
   */
  not_member_id?: string;
  /**
   * 备注
   */
  remark?: string;
  /**
   * 国籍
   */
  nationality?: string;
  /**
   * 国籍
   */
  is_buy_refund?: boolean;
  
  /**
   * 提交时转json字符串 里面包含以下数据,如果是修改里面要加id字段,如果删除的数据不要传给后台
   */
  taxrebates_items: DrawbackItem[];
}

/**
 * 退税登记表单默认值
 */
export const defaultDrawbackInfo: DrawbackInfo = {
  nationality: '',
  is_buy_refund: false,
  taxrebates_items: [
    {
      brand: '',
      money: '',
    }],
};

/**
 * 退税登记表单校验
 */
export const drawbackSchema = Yup.object().shape(
  {
    nationality: Yup.string().ensure().required('请输入国籍'),
    taxrebates_items: Yup.array()
      .of(
        Yup.object({
          brand: Yup.string().ensure().required('请选择退税品牌'),
          money: Yup.string().ensure().required('请输入金额').matches(/^\d+(\.(\d)*)?$/, '请输入正确的金额'),
        })
      )
      .min(1, '请输入退税信息')
      .required('请输入退税信息'),
  }
);